import { Stack } from 'libs/ui';
import { styled } from 'libs/ui/styled';

export const ContentStackStyled = styled(Stack)(() => ({
  '.table-footerContainer': {
    margin: '0 -24px',
    paddingRight: '20px',
  },
}));
